import { api } from '@/api'

export interface ToggleServiceStatusPayload {
  is_active: boolean
}

export function toggleServiceStatusAction(serviceSlug: string, payload: ToggleServiceStatusPayload) {
  return api.v2.patch(`/services/${serviceSlug}/toggle-status`, payload as unknown as Record<string, unknown>)
}
